module.exports = __webpack_public_path__ + "assets/img/1021.dd095ff1.svg";